import http from "@/services/http";
import {ref} from 'vue';
import {useAuth} from "@/services/auth.js";

export const clientes = () => {
  const auth = useAuth();
  // Mensagem de erro da última tentativa de cadastro (ex.: sem permissão,
  // nome obrigatório), mesmo padrão de `vendas.js` — a tela mostra o
  // motivo de verdade em vez de um texto genérico.
  const lastErrorMessage = ref(null);

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/customers', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function getAccontValue(id) {
    let retorno;
    try {
        const {data} = await http.get('/customers/' + id + '/on-account', auth.getBearer());
        retorno = data.value;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function AccontPayment(idcliente, value, paymentMethodId, description) {
    const dados = {
            customer_id: idcliente,
            value: value,
            payment_method_id: paymentMethodId,
            description: description
    };
    try {
      const {data} = await http.post('/account-payment', dados, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function create(payload) {
    const dados = {
      name: payload.name,
      phone: payload.phone || null,
      andress: payload.andress || null,
      createaccount: !!payload.createaccount,
    };
    try {
      const {data} = await http.post('/customers', dados, auth.getBearer());
      lastErrorMessage.value = null;
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, getAccontValue, AccontPayment, create, lastErrorMessage}
}
